export enum ConnectedAccountEntityType {
    Payout = 'payout',
    Charge = 'charge',
    Fee = 'fee',
    CurrencyConversion = 'currency-conversion',
    ConnectedAccountCurrencyConversion = 'connected-account-currency-conversion',
    AirwallexTransfer = 'airwallex-transfer',
    Transaction = 'transaction',
}
